import { Component, Input, OnInit } from '@angular/core';
import { GridRegistrationStatusEnum } from '@bo-client/activation-management/grid-registration/model/grid-registration.enum';

@Component({
  selector: 'app-show-state-grid-registration',
  templateUrl: './show-state-grid-registration.component.html',
  styleUrls: ['./show-state-grid-registration.component.scss']
})
export class ShowStateGridRegistrationComponent implements OnInit {
  @Input() id: number;
  @Input() state: string;
  @Input() statusFeedInManagementLoop: string = null;
  @Input() title: null;

  constructor() {}

  ngOnInit(): void {}
}
